// import firebase from "firebase/app"
// import "firebase/messaging"
// import 'firebase/firestore'

// firebase.initializeApp({
//   apiKey: "AIzaSyDZjAMqmqMFwnx0yDVkqNAD3sI4S_c91Ps",
//   authDomain: "amanata-e46ee.firebaseapp.com",
//   projectId: "amanata-e46ee",
//   storageBucket: "amanata-e46ee.appspot.com",
//   messagingSenderId: "272603181136",
//   appId: "1:272603181136:web:1051b3e4422b451fe16155"
// })

// if (!firebase.apps.length) {
//   firebase.initializeApp(config)
// }

// navigator.serviceWorker
//   .register("firebase-messaging-sw.js", {
//     scope: "firebase-cloud-messaging-push-scope",
//   })
//   .then((registration) => {
//     const messaging = firebase.messaging()

//     messaging.useServiceWorker(registration)
//   })
//   .catch((err) => {
//     console.log(err)
//   })

// export const db = firebase.firestore()

// export default firebase

import firebase from 'firebase'

const config = {
  apiKey: "AIzaSyDZjAMqmqMFwnx0yDVkqNAD3sI4S_c91Ps",
  authDomain: "amanata-e46ee.firebaseapp.com",
  projectId: "amanata-e46ee",
  storageBucket: "amanata-e46ee.appspot.com",
  messagingSenderId: "272603181136",
  appId: "1:272603181136:web:1051b3e4422b451fe16155"
}

if (!firebase.apps.length) {
  firebase.initializeApp(config)
}

const messaging = firebase.messaging()

messaging.usePublicVapidKey("BGgEjX_ulpP06fuu7MHFeeskJrWhW0NdK-qaC09TObYF2eXV_XqzotvM9mJ77ppOyvWYeXc1_fuHhmSU-JvyPQY")

export default firebase